// import { ifAuthenticated } from "@/Modules/User/Routes/guards"

export default [
  {
    path: "/codelists",
    name: "codeLists",
    meta: { title: "Codelists" },
    component: () => import(/* webpackChunkName: "codelists" */ "@/Modules/Codelist/Views/List.vue")
    // beforeEnter: ifAuthenticated
  }
]
